import {
  fetchClient
} from "./chunk-K342ITN7.mjs";
import {
  generateRecaptchaToken
} from "./chunk-W4XMZLKW.mjs";
import {
  __async
} from "./chunk-DFMI36TU.mjs";

// src/core/wbk/qitaf/redeemQitaf.ts
import { Exception } from "@wbk/logger";
import { generateMd5 } from "@wbk/utils";
var redeemQitaf = (_0) => __async(void 0, [_0], function* ({ otp, amount, phone, email }) {
  var _a;
  try {
    const signature = generateMd5(email);
    const captcha = yield generateRecaptchaToken("redeem_qitaf");
    const data = yield fetchClient({
      url: "/qitaf/redeem-to-wallet",
      options: {
        method: "POST",
        body: JSON.stringify({
          otp,
          points: amount,
          msisdn: phone,
          signature,
          captcha
        })
      }
    });
    if (data.status !== "success") {
      throw new Error(((_a = data == null ? void 0 : data.error) == null ? void 0 : _a.message) || (data == null ? void 0 : data.message) || "Something went wrong");
    }
    return data;
  } catch (error) {
    throw new Exception({
      error,
      name: "redeemQitafException",
      context: { tags: { journey: "qitaf" } }
    });
  }
});

export {
  redeemQitaf
};
//# sourceMappingURL=chunk-UGWT7YSQ.mjs.map